import React from 'react';
import { Link } from 'react-router-dom';
import PictureImg from '../../common/PictureImg';
import { getImgAlt } from 'utils/img';
import style from './styles/ng_card.module.scss';

import { ReactComponent as NoNgImage } from 'assets/icons/no_ng.svg';

const NomenclatureGroupsCard = ({ group }) => {
  const { image, title, slug } = group;
  return (
    <Link to={`/ng/${slug}`} className={style.card}>
      {image ? (
        <PictureImg
          src={image}
          webp={group.image_webp}
          alt={getImgAlt(group)}
          loading="lazy"
          className={style.card__image}
          width={232}
          height={150}
        />
      ) : (
        <NoNgImage className={style.card__image} />
      )}

      <span className={style.card__title}>{title}</span>
    </Link>
  );
};

export default NomenclatureGroupsCard;
